import React from 'react';
import PropTypes from 'prop-types';
import Input from '@Components/Input';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { ButtonWithIcon } from '@els/els-react--button';
import { SingleSelect } from '@els/els-react--select';
import LoginFormHeader from '../../Components/LoginFormHeader';

import './RegisterFinalizeForm.scss';
import '../../Components/LoginForm.scss';

function RegisterFinalizeForm({ ipAddress, isLoading, submit, data, marketingInfo, setData, registerFinalizeFail }) {
  const spinnerId = 'finalize-register-page';

  const mapDropdownItems = (items) => {
    if (!items || !items.length) {
      return [];
    }
    return items.map((item) => ({
      label: item.name,
      value: item.id,
    }));
  };

  const mappedUserAERoles = mapDropdownItems(marketingInfo.userAERoles);
  const mappedSubjectAreas = mapDropdownItems(marketingInfo.subjectAreas);
  const mappedOrganizationTypes = mapDropdownItems(marketingInfo.organizationTypes);

  const submitHandler = () => {
    if (!data.organizationType || !data.subjectAreas || !data.userRole) {
      return;
    }
    submit();
  };

  const onChangeOrganizationName = (value) => {
    setData({
      organizationName: value,
    });
  };

  const onSelectUserRole = (value) => {
    setData({ userRole: value });
  };

  const onSelectSubjectArea = (value) => {
    setData({ subjectAreas: value });
  };

  const onSelectOrganizationType = (value) => {
    setData({ organizationType: value });
  };

  return (
    <div className="login-form login-page-form-wrapper register-finalize-form">
      <LoginFormHeader
        ipAddress={ipAddress}
        actionMessage="Finalise your registration"
        infoMessage=" You've approved that we send an email regarding our product. To make sure that we send relevant
              information regarding your business and interested we need the following information."
      />
      <form name="registerFinalizeForm">
        <div className="login-form__content">
          {isLoading && <SimpleSpinner id={spinnerId} />}
          <div className="finalize-register-name__dropdown u-els-margin-top">
            <SingleSelect
              id="finalize-register-userRole-dropdown"
              className="e2e-finalize-register-userRole-dropdown"
              options={mappedUserAERoles}
              data-e2e="finalize-register-userRole-dropdown"
              selectedOptions={data.userRole ? [data.userRole] : undefined}
              label="Your role in the organization?"
              placeholderText="Your role in the organization?"
              onSelect={onSelectUserRole}
              size="small"
              required
              shouldHideLabel
            />
          </div>

          <div className="finalize-register-name__dropdown u-els-margin-top">
            <SingleSelect
              id="finalize-register-subjectArea-dropdown"
              className="e2e-finalize-register-subjectArea-dropdown"
              options={mappedSubjectAreas}
              data-e2e="finalize-register-subjectArea-dropdown"
              selectedOptions={data.subjectAreas ? [data.subjectAreas] : undefined}
              label="Your subject area"
              placeholderText="Your subject area"
              onSelect={onSelectSubjectArea}
              size="small"
              required
              shouldHideLabel
            />
          </div>

          <div className="els-text-input u-els-float-none">
            <Input
              clearButton={false}
              id="finalize-register-organization-name"
              name="organizationName"
              classNameInput="e2e-finalize-register-organization-name"
              animatedPlaceholder
              placeholder="Organization name"
              value={data.organizationName}
              onChange={onChangeOrganizationName}
              required
              debounceDelay={0}
            />
          </div>

          <div className="finalize-register-name__dropdown u-els-margin-top">
            <SingleSelect
              id="finalize-register-organizationType-dropdown"
              className="e2e-finalize-register-organizationType-dropdown"
              options={mappedOrganizationTypes}
              selectedOptions={data.organizationType ? [data.organizationType] : undefined}
              label="Organization type"
              data-e2e="finalize-register-organizationType-dropdown"
              placeholderText="Organization type"
              onSelect={onSelectOrganizationType}
              size="small"
              required
              shouldHideLabel
            />
          </div>
          {registerFinalizeFail && <div className="login-form__content_error u-els-margin-top">{registerFinalizeFail}</div>}

          <div className="login-form__content_actions">
            <div className="login-form__content_actions-button">
              <ButtonWithIcon
                type="primary"
                sprite="ChevronRight"
                iconRight
                data-e2e="finalize-register-submit-button"
                disabled={isLoading}
                onClick={submitHandler}
                className="e2e-login-sign-in">
                Stay up to date
              </ButtonWithIcon>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

RegisterFinalizeForm.propTypes = {
  data: PropTypes.shape({
    subjectAreas: PropTypes.string,
    userRole: PropTypes.string,
    organizationType: PropTypes.string,
    organizationName: PropTypes.string,
  }),
  marketingInfo: PropTypes.shape({
    organizationTypes: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })),
    subjectAreas: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })),
    userAERoles: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, name: PropTypes.string })),
  }),
  setData: PropTypes.func,
  ipAddress: PropTypes.string,
  registerFinalizeFail: PropTypes.string,
  isLoading: PropTypes.bool,
  submit: PropTypes.func.isRequired,
};

export default RegisterFinalizeForm;
